// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"da4ae43c","845":"e08a5b6c"}[chunkId] + ".chunk.js";
};